import {Component, EventEmitter, Input, Output, inject} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {IconBadgeComponent} from "../../../shared/elements/icon-badge/icon-badge.component";
import {DocumentService} from "../../../shared/services/document.service";
import {FileStorageResource} from '../../../shared/types/generated/fileStorageResource';
import {NgSrcImageErrorDirective} from '../../../shared/directives/ng-src-image-error.directive';

@Component({
    selector: 'app-item-documents-preview-available',
    imports: [
        TooltipComponent,
        IconBadgeComponent,
        NgOptimizedImage,
        NgSrcImageErrorDirective
    ],
    templateUrl: './item-documents-preview-available.component.html',
    styleUrl: './item-documents-preview-available.component.scss'
})
export class ItemDocumentsPreviewAvailableComponent {
  public documentService: DocumentService = inject(DocumentService);
  
  @Input() public file: FileStorageResource | null = null;
  @Input() public files: FileStorageResource[] = [];
  @Input() public multiple: boolean = true;
  @Input() public selectable: boolean = true;
  @Output() public  filesChange: EventEmitter<FileStorageResource[]> = new EventEmitter<FileStorageResource[]>();

  public get imageSource(): string | null {
    if (!this.file || this.file.type !== 'image') {
      return null;
    }

    return this.file.preview || this.file.path;
  }

  public openGallery(event: MouseEvent, document: FileStorageResource): void {
    event.stopPropagation();
    this.documentService.showGallery([document], document);
  }

  public opensDocument(document: FileStorageResource): boolean {
    return !this.selectable && document.type !== 'image' && document.type !== 'video';
  }

  public opensGallery(document: FileStorageResource): boolean {
    return !this.selectable && (document.type === 'image' || document.type === 'video');
  }

  public hasTileAction(document: FileStorageResource): boolean {
    return this.opensDocument(document) || this.opensGallery(document);
  }

  public onTileClick(document: FileStorageResource): void {
    if (this.opensGallery(document)) {
      this.documentService.showGallery([document], document);
      return;
    }

    if (this.opensDocument(document)) {
      this.documentService.openDocument(document);
      return;
    }

    this.selectDocument(document);
  }

  public onTileKeydown(event: KeyboardEvent, document: FileStorageResource): void {
    if (event.target !== event.currentTarget || !this.hasTileAction(document) || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    if (event.key === ' ') {
      event.preventDefault();
    }

    this.onTileClick(document);
  }

  public downloadDocumentFromAction(event: MouseEvent, document: FileStorageResource): void {
    event.stopPropagation();
    this.documentService.downloadDocument(document);
  }

  public isSelected(document: FileStorageResource): boolean {
    return this.files.some(file => file.uuid === document.uuid);
  }

  public selectDocument(document: FileStorageResource): void {
    if (this.isSelected(document)) {
      this.files = this.files.filter(file => file.uuid !== document.uuid);
    } else if (!this.multiple) {
      this.files = [document];
    } else {
      this.files = [...this.files, document];
    }
    this.filesChange.emit(this.files);
  }

}
